/**
 * 티켓 서비스
 */

import apiClient from './api';
import { Ticket, TicketFilter, TicketListResponse } from '../types/ticket';

export const ticketService = {
  /**
   * 티켓 목록 조회
   */
  async getTickets(filter: TicketFilter = {}): Promise<TicketListResponse> {
    const params = new URLSearchParams();
    
    if (filter.status) params.append('status', filter.status);
    if (filter.ticket_type) params.append('ticket_type', filter.ticket_type);
    if (filter.date_from) params.append('date_from', filter.date_from);
    if (filter.date_to) params.append('date_to', filter.date_to);
    if (filter.ticket_number) params.append('ticket_number', filter.ticket_number);
    if (filter.booking_number) params.append('booking_number', filter.booking_number);
    if (filter.hall_id) params.append('hall_id', filter.hall_id.toString());
    if (filter.package_id) params.append('package_id', filter.package_id.toString());
    if (filter.page) params.append('page', filter.page.toString());
    if (filter.limit) params.append('limit', filter.limit.toString());

    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: TicketListResponse }>(`/admin/tickets?${params.toString()}`);
    // return response.data.data;

    // 임시: 더미 데이터 반환
    return {
      tickets: [],
      pagination: {
        current_page: 1,
        total_pages: 1,
        total_count: 0,
        limit: 20,
      },
    };
  },

  /**
   * 티켓 상세 조회
   */
  async getTicket(id: number): Promise<Ticket> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: { ticket: Ticket } }>(`/admin/tickets/${id}`);
    // return response.data.data.ticket;

    throw new Error('Not implemented');
  },

  /**
   * 티켓 입장 이력 조회
   */
  async getTicketEntryHistory(id: number): Promise<Ticket['entry_history']> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: { entries: Ticket['entry_history'] } }>(`/admin/tickets/${id}/entries`);
    // return response.data.data.entries;

    return [];
  },

  /**
   * 티켓 입장 검증 (관리자용)
   */
  async validateEntry(ticketCode: string, hallId: number): Promise<{ success: boolean; message: string }> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.post<{ data: { success: boolean; message: string } }>('/admin/tickets/validate-entry', {
    //   ticket_code: ticketCode,
    //   hall_id: hallId,
    // });
    // return response.data.data;

    throw new Error('Not implemented');
  },

  /**
   * 티켓 취소
   */
  async cancelTicket(id: number, reason?: string): Promise<Ticket> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.post<{ data: { ticket: Ticket } }>(`/admin/tickets/${id}/cancel`, { reason });
    // return response.data.data.ticket;

    throw new Error('Not implemented');
  },
};

